module.exports = __webpack_public_path__ + "static/media/Hyatt-Regency-Aqaba.f8be77aa.jpg";